import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../common/components/Navbar/Navbar";
import AnnouncementBar from "../pages/homepage/components/AnnouncementBar";
import LogoLoader from "../common/components/Loaders/LogoLoader";
import Footer from "../common/components/Footer/Footer";
import ClarityProvider from "../providers/ClarityProvider";

const ServicesLayoutOne = () => {
  // React.useEffect(() => {
  //   document.body.style.overflow = "hidden";
  //   return () => {
  //     document.body.style.overflow = "auto";
  //   };
  // }, []);

  return (
    <>
      <ClarityProvider />
      <Navbar />{" "}
      <AnnouncementBar />
      <main id="layout">
        <React.Suspense fallback={<LogoLoader />}>
          <Outlet />
          <Footer />
        </React.Suspense>
      </main>
    </>
  );
};

export default ServicesLayoutOne;
